export const colors = {
  gridLines: 0xcb8999,
  cellFontColor: 0x000000,
  cellColorUserText: 0x8ecb89,
  cellColorUserPython: 0x8c1a6a,
  cursorCell: 0x6cd4ff,
  highlightYellow: 0xffc800,
  independence: 0x5d576b,
  headerBackgroundColor: 0xffffff,
  headerCornerBackgroundColor: 0xffffff,
  lightGray: '#f6f8fa',
  mediumGray: '#cfd7de',
  darkGray: '#55606b',
  quadraticPrimary: '#6CD4FF',
  quadraticSecondary: '#8ECB89',
  quadraticThird: '#CB8999',
  quadraticForth: '#FFC800',
  quadraticFifth: '#5D576B',
  colorPython: '#8c1a6a',
};
